import { render } from "./VFormGroupInputCheckbox.vue?vue&type=template&id=5154a2ee&scoped=true&ts=true"
import script from "./VFormGroupInputCheckbox.vue?vue&type=script&lang=ts"
export * from "./VFormGroupInputCheckbox.vue?vue&type=script&lang=ts"

import "./VFormGroupInputCheckbox.vue?vue&type=style&index=0&id=5154a2ee&lang=scss&scoped=true"

import exportComponent from "/opt/atlassian/pipelines/agent/build/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5154a2ee"]])

export default __exports__